import styled from 'styled-components';
import { Flex, FormControls } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { UseFormWatch } from 'react-hook-form';
import SeverityRenderer from 'shared/components/SeverityRenderer';
import { AddTestForm } from 'shared/types';

const ItemChip = styled(Flex)`
  border: 1px solid ${({ theme }) => theme.palette.common.gray11};
  padding: 8px 16px;
  border-radius: 6px;
  width: fit-content;
`;

const detectionTypeLabelMap = {
  anomaly: 'anomalies',
  drop: 'drops',
  spike: 'spikes',
};

type Props = {
  watch: UseFormWatch<AddTestForm>;
};

const TablesDimensionAnomaliesConfig = ({ watch }: Props) => (
  <>
    {watch('timestampColumn') && (
      <FormControls.FormText>
        Timestamp column: <b>{watch('timestampColumn')}</b>
      </FormControls.FormText>
    )}

    {watch('columnGroup') && (
      <Flex sx={{ gap: 2, alignItems: 'center' }}>
        <FormControls.FormText>
          count rows grouped by the following columns:
        </FormControls.FormText>
        <Flex sx={{ gap: 1 }}>
          {watch('columnGroup').map((col) => (
            <ItemChip key={col}>
              <Typography>{col}</Typography>
            </ItemChip>
          ))}
        </Flex>
      </Flex>
    )}

    <FormControls.FormText>
      Detect <b>{detectionTypeLabelMap[watch('detectionEventType')]}</b> in the
      values distribution of the selected dimensions by looking at a{' '}
      <b>
        {watch('detectionPeriod')} {watch('detectionUnit')}
      </b>{' '}
      period to the last <b>{watch('detectionDaysBack')}</b> days
    </FormControls.FormText>

    <SeverityRenderer severity={watch('severity')?.type || 'error'} />
  </>
);

export default TablesDimensionAnomaliesConfig;
